import React from "react";
import { useNavigate } from "react-router-dom";
import { FeatureLockModal as SharedFeatureLockModal } from "../../../../../shared/frontend/billing/FeatureLockModal";
import type { FeatureTeaserData } from "../../../../../shared/frontend/billing/featureLockTypes";
import type { FeatureAccessResult } from "../app/auth/useFeatureAccess";
import type { LocalizedText } from "../app/i18n/i18n";

export type FeatureLockModalProps = {
  open: boolean;
  onClose: () => void;
  access: FeatureAccessResult | null;
  text: (t: LocalizedText) => string;
};

export function FeatureLockModal({ open, onClose, access, text }: FeatureLockModalProps) {
  const nav = useNavigate();

  if (!access) return null;

  const feature: FeatureTeaserData = {
    title: text(access.metadata.title),
    description: text(access.metadata.description),
    badgeText: text(access.metadata.badgeText),
    highlights: access.metadata.highlights?.map((h) => text(h)),
    upgradeUrl: access.upgradeUrl,
    planName: access.metadata.planName ? text(access.metadata.planName) : undefined,
    planPriceText: access.metadata.planPriceText ? text(access.metadata.planPriceText) : undefined,
    addonName: access.metadata.addonName ? text(access.metadata.addonName) : undefined,
    addonPriceText: access.metadata.addonPriceText ? text(access.metadata.addonPriceText) : undefined,
    tariffNotice: text({
      de: "In der Tarifverwaltung unter Abrechnung können Sie Ihren Tarif wechseln oder einzelne Optionen direkt zubuchen.",
      en: "In billing settings, you can change your plan or book individual options directly."
    }),
  };

  return (
    <SharedFeatureLockModal
      open={open}
      onClose={onClose}
      feature={feature}
      onUpgrade={() => {
        onClose();
        nav(access.upgradeUrl);
      }}
      upgradeLabel={text({ de: "zur Tarifauswahl", en: "to plan selection" })}
      cancelLabel={text({ de: "abbrechen", en: "cancel" })}
      benefitsTitle={text({
        de: "im Modul enthalten:",
        en: "Included with this module:",
      })}
    />
  );
}
